/**
 * Stories implemented.
 */
/* eslint-disable local-rules/require-storybook-documentation */

import { Component, ErrorInfo, ReactNode } from 'react';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export const ErrorBoundaryError = createDatadogError('ErrorBoundary');

export class ErrorBoundary extends Component<
    { children: ReactNode; onError: (error: unknown, context?: object | undefined) => void; fallback: ReactNode },
    { hasError: boolean }
> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorBoundaryContext: ErrorInfo) {
        const _error = new ErrorBoundaryError(`A fatal error has occurred`);
        _error.stack = errorBoundaryContext.componentStack ?? undefined;
        this.props.onError(_error, { errorBoundaryContext, error });
    }

    render() {
        const { fallback, children } = this.props;
        const { hasError } = this.state;
        if (hasError) {
            return fallback;
        }

        return children;
    }
}
